/* global process */
import React, { PureComponent } from 'react';
import Loadable from 'react-loadable';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Loading, Spinner, SetGlobalStyle, Header, COLORS, Button } from '@vezeeta/web-components';
import Cookies from 'js-cookie';
import { Box } from 'grid-styled';
import { Provider } from 'react-redux';
import '@vezeeta/enterprise-modals/lib/Modal.scss';

import IconsStore from './IconsStore';
import store from '../store';
import './App.scss';

// Async loading components

const Login = Loadable({
  loader: () => import('./login/Login'),
  loading: Loading,
});

const VezeetaAdmin = Loadable({
  loader: () => import('./vezeetaAdmin/VezeetaAdminContainer'),
  loading: Loading,
});

const UserPortal = Loadable({
  loader: () => import('./userPortal/UserPortalContainer'),
  loading: Loading,
});

const routes = [
  {
    component: Login,
    route: '/login',
  },
  {
    component: VezeetaAdmin,
    route: '/vezeetaAdmin',
  },
  {
    component: UserPortal,
    route: '/userPortal',
  },
];

class App extends PureComponent {
  constructor(props) {
    super(props);

    SetGlobalStyle();

    this.state = {
      isLoading: false,
    };
  }

  componentDidMount() {
    // Set the background image
    document.body.style.backgroundImage = `url("${
      process.env.REACT_APP_CDN_URL
    }/assets/background-sm.png")`;

    this.backgroundImg.onload = () => {
      document.body.style.backgroundImage = `url("${
        process.env.REACT_APP_CDN_URL
      }/assets/background.png")`;
    };
  }

  onLogout = () => {
    Cookies.remove('AUTH_TOKEN');
    window.location.pathname = '/';
  };

  render() {
    let body;
    const headerItems = (
      <Button
        onClick={this.onLogout}
        primary
        color={COLORS.PRIMARY_BLUE}
        icon={IconsStore.getIcon('logout')}
      >
        Logout
      </Button>
    );

    if (!this.state.isLoading) {
      body = (
        <Box>
          <Switch>
            {routes.map(route => (
              <Route key={route.route} path={route.route} component={route.component} />
            ))}
            <Redirect to="/login" />
          </Switch>
        </Box>
      );
    } else {
      body = (
        <div className="loading-routes">
          <Spinner />
        </div>
      );
    }

    return (
      <Provider store={store}>
        <Router history={this.browserHistory}>
          <div className="App">
            <img
              src={`${process.env.REACT_APP_CDN_URL}/assets/background.png`}
              ref={img => {
                this.backgroundImg = img;
              }}
              className="hide"
              alt="logo"
            />
            <Header
              items={
                window.location.pathname === '/login' || window.location.pathname === '/'
                  ? null
                  : headerItems
              }
              onLogoClick={() => {
                window.location = window.location.href;
              }}
              logoUrl={`${process.env.REACT_APP_CDN_URL}/assets/logo.png`}
              px={4}
              bg={COLORS.PRIMARY_BLUE}
            />
            {body}
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
